import { createAction, props } from '@ngrx/store';

export const exportWithdrawList = createAction('[Contact Support Drawer] Export Withdraw List');
export const exportWithdrawListSuccess = createAction(
  '[Contact Support Drawer] Export Withdraw List Success',
  props<{ fileBlob: Blob }>()
);
export const exportWithdrawListFail = createAction('[Contact Support Drawer] Export Withdraw List Fail');
